import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const avatarIcon = (theme: Theme) => css`
  margin-right: ${theme.spacing[12]};
`;

export const styledEndAdornment = styled('div')(
  ({ theme }: { theme: Theme }) => `
  margin-left: ${theme.spacing[16]};
`,
);

export const disabled = (theme: Theme) => css`
  color: ${theme.palette.text.disabled};
`;

export const icon = css`
  border-width: 0;
`;
